import React from 'react';
import MainPanel from './mainpanel';
import QuickDetails from '@components/configure/quickdetails/quickdetails';
import Sidebar from './sidebar';
import Typography from '@components/typography';
import Tooltip from '@components/tooltip';
import '@styles/configure/detailscontainer.scss';
import '@styles/quickdetails.scss';
import { VehicleProps, VehicleQuickDetails } from 'interface';
import { carQuoteIdTooltip } from '../../../resources';

const VehicleDetails: React.FC<VehicleProps> = ({ vehicle }) => {
  const vehicleId = `ID: ${vehicle.id}`;
  return (
    <section className="details wide-component-container">
      <div className="vehicleid">
        <Tooltip
          id="vehicleId"
          text={vehicleId}
          delayHide={100}
          data-cy="vehicle-id-tooltip"
        >
          <Typography variant="caption" size="xs" colour="alternative">
            {carQuoteIdTooltip}
          </Typography>
        </Tooltip>
      </div>
      <QuickDetails
        data-cy="qd"
        data-testid="qd"
        vehicle={vehicle as VehicleQuickDetails}
      />
      <MainPanel vehicle={vehicle} />
      <Sidebar />
    </section>
  );
};

export default VehicleDetails;
